const alertingData = {
  id: 4,
  title: "Alerting",
  subtitle: "Client and Ticker Alerts for Traders",
  blurb: [""],

  bkgd: "var(--alerting-bkgd)"
};

export default alertingData;
